class CommonUtilities {

    static statusOptions = [
        { id: 1, value: "All", name: "All" },
        { id: 2, value: "Approved", name: "Approved" },
        { id: 3, value: "Completed", name: "Completed" },
        { id: 4, value: "Pending", name: "Pending" },
        { id: 5, value: "Requires Additional Documentation", name: "Requires Additional Documentation" },
        { id: 6, value: "Rejected", name: "Rejected" },
        { id: 7, value: "Cancelled", name: "Cancelled" },
    ];
    static monthOrderList = ["Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May", "Jun"];//lowercase 
    static monthOrderUppercaseList = ['JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC', 'JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN']; //uppercase 

    static monthRegularList = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    static monthsOptions = [
        { id: 1, value: "Jul", name: "July" },
        { id: 2, value: "Aug", name: "August" },
        { id: 3, value: "Sep", name: "September" },
        { id: 4, value: "Oct", name: "October" },
        { id: 5, value: "Nov", name: "November" },
        { id: 6, value: "Dec", name: "December" },
        { id: 7, value: "Jan", name: "January" },
        { id: 8, value: "Feb", name: "February" },
        { id: 9, value: "Mar", name: "March" },
        { id: 10, value: "Apr", name: "April" },
        { id: 11, value: "May", name: "May" },
        { id: 12, value: "Jun", name: "June" }
    ];
    static monthsOrderListOptions = [
        { id: 1, value: "Jul", name: "July" },
        { id: 2, value: "Aug", name: "August" },
        { id: 3, value: "Sep", name: "September" },
        { id: 4, value: "Oct", name: "October" },
        { id: 5, value: "Nov", name: "November" },
        { id: 6, value: "Dec", name: "December" },
        { id: 7, value: "Jan", name: "January" },
        { id: 8, value: "Feb", name: "February" },
        { id: 9, value: "Mar", name: "March" },
        { id: 10, value: "Apr", name: "April" },
        { id: 11, value: "May", name: "May" },
        { id: 12, value: "Jun", name: "June" },
    ];

    static quarterOptions = [
        { id: 1, value: "Q1", name: "Q1 Jul-Sep" },
        { id: 2, value: "Q2", name: "Q2 Oct-Dec" },
        { id: 3, value: "Q3", name: "Q3 Jan-Mar" },
        { id: 4, value: "Q4", name: "Q4 Apr-Jun" },
    ];
    static semiannuallyOptions = [
        { id: 1, value: "SA1", name: "Jul-Dec" },
        { id: 2, value: "SA2", name: "Jan-Jun" },
    ];
    static yearlyTypeOptions = [
        { id: 1, value: "monthly_values", name: "Monthly Values" },
        { id: 2, value: "yearly_values", name: "Yearly Values" },
    ];
    static periodOptions = [
        { id: 0, value: "", name: "Select" },
        { id: 1, value: "MONTHLY", name: "Monthly" },
        { id: 2, value: "QUARTERLY", name: "Quarterly" },
        { id: 2, value: "SEMIANNUALLY", name: "Semi-annually" },
        { id: 2, value: "YEARLY", name: "Yearly" },
    ];
    static columnName = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "AA", "AB", "AC", "AD", "AE", "AF", "AG", "AH", "AI", "AJ", "AK", "AL", "AM", "AN", "AO", "AP", "AQ", "AR", "AS", "AT", "AU", "AV", "AW", "AX", "AY", "AZ", "BA", "BB", "BC", "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BK", "BL", "BM", "BN", "BO", "BP", "BQ", "BR", "BS", "BT", "BU", "BV", "BW", "BX", "BY", "BZ"]

    static dioceseGLMappingOptions = [
        { id: 1, value: "Options1", name: "Options1" },
        { id: 2, value: "Options2", name: "Options2" },
    ];
    static manualTransactionTypes = [
        { id: 0, value: "", name: "Select" },
        { id: 1, value: "DR", name: "Withdrawal" },
        { id: 2, value: "CR", name: "Deposit" },
    ];
    static invoiceTransactionTypes = [
        { id: 0, value: "", name: "Select" },
        { id: 1, value: "DI", name: "Diocesan" },
        { id: 2, value: "VI", name: "Vendor" },
    ];
    static creditLineTransactionTypes = [
        { id: 0, value: "", name: "Select" },
        { id: 1, value: "DR", name: "Withdrawal" },
        { id: 2, value: "CR", name: "Payment" },
    ];

    static methodOfPayments = [
        { id: 0, value: "", name: "Select" },
        { id: 1, value: "Check", name: "Check" },
        { id: 2, value: "ACH", name: "ACH" },
    ];
    static entityTypesOptions = ["All", "Checking", "CreditLine", "Loan", "Savings"];

    static responseTypesOptions = ["All", "Request", "Response"];

    static blackBaudStatusOptions = ["All", "Error", "Failed", "Pending", "Success"];

    static batchStatusOptions = ["All", "Failed", "Pending", "Submission Failed", "Submitted", "Success"];

    static statusItems = ["Active", "Opened", "Suspended", "Inactive"];

    static statusItem = ["Active", "Opened", "Suspended"];

    static adjustmentCategory = ["All", "Equity", "Loan Payable"];

    static statusTypes = ["All", "Error", "Failed", "Success"];

    static paginationOptions = [5, 10, 25, 50, 100];

    static participantTypeRcboOptions = ["Select", "Church", "Cemetery", "Hospitals", "School"];
    static participantTypeDcgaryOptions = ["Select", "Church", "School"];

}

export default CommonUtilities;
